import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class extends Controller {
  static targets = ['message'];

  connect() {
    this.#fallback = Turbo.config.forms.confirm;

    Turbo.config.forms.confirm = (message) => this.#ask(message);

    this.#onBeforeMorph = (event) => {
      if (event.target === this.element && this.element.open) event.preventDefault();
    };

    document.addEventListener('turbo:before-morph-element', this.#onBeforeMorph);
  }

  disconnect() {
    Turbo.config.forms.confirm = this.#fallback;

    document.removeEventListener('turbo:before-morph-element', this.#onBeforeMorph);
  }

  accept() {
    this.#answer = true;
    this.element.close();
  }

  decline() {
    this.element.close();
  }

  settle() {
    this.#resolve?.(this.#answer);
    this.#resolve = null;
  }

  dismissOnBackdrop(event) {
    if (event.target === this.element) this.element.close();
  }

  #ask(message) {
    this.messageTarget.textContent = message;
    this.#answer = false;
    this.element.showModal();

    return new Promise((resolve) => {
      this.#resolve = resolve;
    });
  }

  #fallback;
  #onBeforeMorph;
  #resolve = null;
  #answer = false;
}
